const colors = require('../../src/styles/colors');

module.exports = {
  siteTitle: 'PersonalBlog - by Marques Woodson', // <title>
  shortSiteTitle: "Marques Woodson's Technical Blog", // <title> ending for posts and pages
  siteDescription: "Marques Woodson's Technical Blog",
  siteUrl: 'https://www.marqueswoodson.com',
  pathPrefix: '',
  siteImage: 'preview.jpg',
  siteLanguage: 'en',
  // author
  authorName: 'marques woodson',
  authorTwitterAccount: 'mwq27',
  // info
  infoTitle: 'marques woodson',
  infoTitleNote: 'personal blog',
  // manifest.json
  manifestName: "Marques Woodson's Technical Blog",
  manifestShortName: 'PersonalBlog', // max 12 characters
  manifestStartUrl: '/',
  manifestBackgroundColor: colors.background,
  manifestThemeColor: colors.background,
  manifestDisplay: 'standalone',
  // contact
  contactEmail: 'hello@marqueswoodson.com',
  // social
  authorSocialLinks: [
    {
      name: 'github',
      url: 'https://github.com/mwq27',
    },
    {
      name: 'twitter',
      url: 'https://twitter.com/mwq27',
    },
  ],
};



// WEBPACK FOOTER //
// ./content/meta/config.js